import PropTypes from 'prop-types';
import React from 'react';
import { Button, Image } from 'react-bootstrap';
import PhotoForm from './PhotoForm';

class Photo extends React.Component {
  constructor(props) {
    super(props);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isEditing: false,
    };
  }
  handleRemove(e) {
    e.preventDefault();
    this.props.removeHotelPhoto(this.props.photo.id);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    const payload = values;
    this.props.editHotelPhoto(this.props.photo.id, payload);
    this.handleClose();
  }

  buildToolbar() {
    return (
      <ul className="hotel-photo-tools">
        <li>
          <Button onClick={this.handleEdit} title="Edit"><i className="fa fa-pencil" /></Button>
        </li>
        <li>
          <Button onClick={this.handleRemove} title="Remove"><i className="fa fa-trash" /></Button>
        </li>
      </ul>
    );
  }
  render() {
    const photo = this.props.photo;
    if (this.state.isEditing) {
      const iv = { name: photo.name };
      return (
        <div className="col-sm-4 col-md-4">
          <div className="thumbnail">
            <Image src={photo.photo} responsive />
            <div className="caption">
              <PhotoForm
                initialValues={iv}
                onSubmit={this.handleSubmit}
                handleClose={this.handleClose}
              />
            </div>
          </div>
        </div>
      );
    }
    const toolbar = this.buildToolbar();
    const name = photo.name ? photo.name : 'Add a Caption';
    let displayName = name;
    if (name.length > 15) {
      displayName = name.slice(0, 14) + "...";
    }
    return (
      <div className="col-sm-4 col-md-4">
        <div className="thumbnail">
          <Image src={photo.photo} responsive />
          <div className="caption">
            <h4 onClick={this.handleEdit}>{displayName}</h4>
            {toolbar}
          </div>
        </div>
      </div>
    );
  }
}
Photo.propTypes = {
  photo: PropTypes.object.isRequired,
  removeHotelPhoto: PropTypes.func.isRequired,
  editHotelPhoto: PropTypes.func.isRequired,
};
export default Photo;



// WEBPACK FOOTER //
// src/routes/hotels/components/Photo.js